import { useTranslation } from "react-i18next";

import { FieldNumber } from "@/ui/field-number";

import { EditorDefaultFields } from "../schema-builder-field-editor-default";

export const EditorNumberFields = () => {
  const { t } = useTranslation();

  return (
    <>
      <EditorDefaultFields />
      <FieldNumber name="min" label={t(`schema:property.min`)} />
      <FieldNumber name="max" label={t(`schema:property.max`)} />
    </>
  );
};
